import * as React from "react";
import { auth } from "../firebase";
import { Button } from 'reactstrap';

export const SignOutButton = () => (
    <Button color="warning" onClick={auth.doSignOut}>Sign Out</Button>
);